import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IAdminAccountInsights {
	summary: string;
	generatedAt: string;
}

export const ADMIN_ACCOUNT_INSIGHTS_QUERY_KEY = 'admin/account/<accountId>/insights';

export function useAdminAccountInsightsQuery({ enabled, accountId }: { enabled?: boolean; accountId: string }) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IAdminAccountInsights>(
				`admin/account/${encodeURIComponent(accountId)}/insights`,
				'GET'
			),
		queryKey: [ADMIN_ACCOUNT_INSIGHTS_QUERY_KEY, accountId],
		enabled,
	});
}
